import React from "react";

import Box from "@mui/material/Box";

const OverflowDiv = React.forwardRef(({ cellContent, width, color, cellStyle, ...props }, ref) => (
  <Box
    ref={ref}
    sx={{
      maxWidth: width,
      minWidth: width,
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
      color: color ?? "black",
      verticalAlign: "middle",
      ...(cellStyle || {}),
    }}
    {...props}
  >
    {cellContent}
  </Box>
));

export default React.memo(OverflowDiv);
